import { DlVault } from 'types/contracts';

export interface GetDirectReferralCountInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetDirectReferralCountOutput = {
  count: number;
};

const getDirectReferralCount = async ({
  dlVaultContract,
  accountAddress,
}: GetDirectReferralCountInput): Promise<GetDirectReferralCountOutput> => {
  const count = await dlVaultContract.methods
    .getDirectReferralCount(accountAddress)
    .call();

  return {
    count: parseInt(count || '0', 10),
  };
};

export default getDirectReferralCount; 